<div id="waitingroom" [style]="'background-image: url(' + organizationSettings.waitingRoomAssets + backgroundImage + ')'">
    <button class="gsk-btn bottom-left-nav-btn" mat-raised-button (click)="toReception()">
        <mat-icon class="back-btn">navigate_before</mat-icon>
        {{ "lecturehall.buttons.reception" | translate }}
    </button>
</div>
